import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import AppStore from "./modules/AppStore";
import AuthStore from "./modules/AuthStore";
import UserStore from "./modules/UserStore";
import ProbeStore from "./modules/ProbeStore";
import SoilTypesStore from "./modules/SoilTypesStore";
import RecTableStore from "./modules/RecTableStore";
import CultureTableStore from "./modules/CultureTableStore";
import CultureGrowthPhaseStore from "./modules/CultureGrowthPhaseStore";
import CalculationTableStore from "./modules/CalculationTableStore";
import DataAnalyticsStore from "@/store/modules/DataAnalyticsStore";
import UserPermissions from "@/store/modules/UserPermissionsStore";
import FormulaTableStore from "@/store/modules/FormulaTableStore";
import SensorErrorStore from "@/store/modules/SensorErrorStore";
import CountryStore from './modules/CountryStore';
import StationMessageStore from "@/store/modules/StationMessageStore";
import GraphStore from "@/store/modules/GraphStore";
import AnnualSummaryStore from "@/store/modules/AnnualSummaryStore";
import QuarterStore from '@/store/modules/QuarterStore';
import StationLocationStore from '@/store/modules/StationLocationStore';
import ReportStore from '@/store/modules/ReportStore';
import CompanyStore from '@/store/modules/CompanyStore';

export default new Vuex.Store({
    modules: {
        'app': AppStore,
        'auth': AuthStore,
        'user': UserStore,
        'probe': ProbeStore,
        'soil': SoilTypesStore,
        'rec': RecTableStore,
        'culture': CultureTableStore,
        'cultureGrowthPhase': CultureGrowthPhaseStore,
        'calculation': CalculationTableStore,
        'analytics': DataAnalyticsStore,
        'userPermissions': UserPermissions,
        'formula': FormulaTableStore,
        'sensorError': SensorErrorStore,
        'country': CountryStore,
        'stationMessage': StationMessageStore,
        'graph': GraphStore,
        'annualSummary': AnnualSummaryStore,
        'quarter': QuarterStore,
        'stationLocation': StationLocationStore,
        'report': ReportStore,
        'company': CompanyStore
    }
});